import React from 'react'
import { Routes, Route } from 'react-router-dom'
import Main from './Main'
import Detail from './intervention/Detail'

const Interventions = () => {
  return (
    <Routes>
      <Route path="" element={<Main />} />
      <Route path=":intervention" element={<Detail />} />
    </Routes>
  )
}

export default Interventions